// ===================================== Recently Items Js =================================

// document.addEventListener('DOMContentLoaded', function(){
//     class RecentlyViewedProducts extends HTMLElement {
//       async connectedCallback() {
//         await this.displayRecentlyViewedProducts();
//       }
    
//       async displayRecentlyViewedProducts() {
//         let recentlyViewed =
//           JSON.parse(localStorage.getItem("recentlyViewedProducts")) || [];
//         recentlyViewed = recentlyViewed.reverse();
    
//         const productHandles = recentlyViewed.map((product) => product.handle);
    
//         if (!productHandles.length) {
//           this.innerHTML = "<p>No recently viewed products.</p>";
//           return;
//         }
    
//         const url = `/collections/all?view=ajax&products=${productHandles.join(",")}`;
    
//         try {
//           const response = await fetch(url);
//           if (!response.ok) throw new Error("Failed to fetch product data");
    
//           const htmlString = await response.text();
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(htmlString, "text/html");
    
//           const recentlyItemsList = doc.querySelector('.recently_items_list');
//           if (recentlyItemsList) {
//             this.innerHTML = recentlyItemsList.innerHTML;
//           } else {
//             this.innerHTML = "<p>No recently viewed products found.</p>";
//           }
//         } catch (error) {
//           console.error("Error:", error);
//           this.innerHTML = "<p>Error loading recently viewed products.</p>";
//         }
//       }
//     }
    
//     customElements.define("recently-viewed", RecentlyViewedProducts);
//     });


// remove current view 
// document.addEventListener('DOMContentLoaded', function(){
//     class RecentlyViewedProducts extends HTMLElement {
//       async connectedCallback() {
//         await this.displayRecentlyViewedProducts();
//       }
//          storeProductInRecentlyViewed(productHandle, Limit) {
//           let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
//           const existingProductIndex = recentlyViewed.findIndex(product => product.handle === productHandle);
//           if (existingProductIndex !== -1) {
//             recentlyViewed.splice(existingProductIndex, 1);
//           }
//           recentlyViewed.push({ handle: productHandle });
//           if (recentlyViewed.length > Limit) {
//             recentlyViewed.shift();
//           }
//           localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewed));
//         }
//       async displayRecentlyViewedProducts() {
//         let recentlyViewed =
//           JSON.parse(localStorage.getItem("recentlyViewedProducts")) || [];
//         recentlyViewed = recentlyViewed.reverse();
    
//         const productHandles = recentlyViewed.map((product) => product.handle);
    
//         if (!productHandles.length) {
//           this.innerHTML = "<p>No recently viewed products.</p>";
//           return;
//         }
    
//         const url = `/collections/all?view=ajax&products=${productHandles.join(",")}`;
    
//         try {
//           const response = await fetch(url);
//           if (!response.ok) throw new Error("Failed to fetch product data");
    
//           const htmlString = await response.text();
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(htmlString, "text/html");
    
//           const recentlyItemsList = doc.querySelector('.recently_items_list');
//           if (recentlyItemsList) {
//             this.innerHTML = recentlyItemsList.innerHTML;
//           } else {
//             this.innerHTML = "<p>No recently viewed products found.</p>";
//           }
//              let Limit = 12;
//           const productHandle = window.productHandle;
//           this.storeProductInRecentlyViewed(productHandle, Limit);
//         } catch (error) {
//           console.error("Error:", error);
//           this.innerHTML = "<p>Error loading recently viewed products.</p>";
//         }
//       }
//     }
    
//     customElements.define("recently-viewed", RecentlyViewedProducts);
//     });
// document.addEventListener('DOMContentLoaded', function () {
//   class RecentlyViewedProducts extends HTMLElement {
//     constructor() {
//       super();
//       this.limitHandler = new LimitHandler();
//     }

//     async connectedCallback() {
//       this.limitHandler.storeCurrentProduct(); // Store current product
//       await this.displayRecentlyViewedProducts();
//     }

//     async displayRecentlyViewedProducts() {
//       let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
//       const currentProduct = window.productHandle;

//       if (!currentProduct) {
//         console.warn("No product handle found.");
//         return;
//       }

//       // Filter out the current product and keep the latest products first
//       recentlyViewed = recentlyViewed.filter(product => product.handle !== currentProduct);


//       if (!recentlyViewed.length) {
//         this.innerHTML = "<p>No recently viewed products.</p>";
//         return;
//       }

//       const productHandles = recentlyViewed.map(product => product.handle);
//       const url = `/collections/all?view=ajax&products=${productHandles.join(",")}`;

//       try {
//         const response = await fetch(url);
//         if (!response.ok) throw new Error("Failed to fetch product data");

//         const htmlString = await response.text();
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(htmlString, "text/html");
//         const recentlyItemsList = doc.querySelector('.recently_items_list');

//         if (recentlyItemsList) {
//           this.innerHTML = recentlyItemsList.innerHTML;
//         } else {
//           this.innerHTML = "<p>No recently viewed products found.</p>";
//         }
//       } catch (error) {
//         console.error("Error:", error);
//         this.innerHTML = "<p>Error loading recently viewed products.</p>";
//       }
//     }
//   }

//   class LimitHandler {
//     constructor() {
//       this.Limit = 12;
//     }

//     storeCurrentProduct() {
//       const productHandle = window.productHandle;
//       if (!productHandle) {
//         console.warn("No product handle found.");
//         return;
//       }


//       this.storeProductInRecentlyViewed(productHandle);
//     }

//     storeProductInRecentlyViewed(productHandle) {
//       let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];

//       // Remove product if already exists
//       recentlyViewed = recentlyViewed.filter(product => product.handle !== productHandle);

//       // Add new product at the **beginning** (most recent first)
//       recentlyViewed.unshift({ handle: productHandle });

//       // Enforce limit
//       if (recentlyViewed.length > this.Limit) {
//         recentlyViewed.pop(); // Remove the oldest product
//       }

//       // Save to localStorage
//       localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewed));
//     }
//   }

//   customElements.define("recently-viewed", RecentlyViewedProducts);
// });

document.addEventListener('DOMContentLoaded', async function () {
  class LimitHandler {
    constructor() {
      this.Limit = 9;
    }

    storeCurrentProduct() {
      const productHandle = window.productHandle;
      if (!productHandle) {
        console.warn("No product handle found.");
        return;
      }

      this.storeProductInRecentlyViewed(productHandle);
    }

    storeProductInRecentlyViewed(productHandle) {
      let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];

      recentlyViewed = recentlyViewed.filter(product => product.handle !== productHandle);
      recentlyViewed.unshift({ handle: productHandle });

      if (recentlyViewed.length > this.Limit) {
        recentlyViewed.pop();
      }

      localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewed));
    }
  }

  async function displayRecentlyViewedProducts(container) {
    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
    const currentProduct = window.productHandle;

    function hideRecentlyViewedSection() {
      // Shopify usually wraps sections with .shopify-section
      const sectionWrapper =
        container.closest('.shopify-section') ||
        container.closest('section') ||
        container.closest('.section');

      if (sectionWrapper) sectionWrapper.style.display = 'none';
      container.innerHTML = '';
    }

    if (!currentProduct) {
      console.warn("No product handle found.");
      return;
    }

    recentlyViewed = recentlyViewed.filter(product => product.handle !== currentProduct);

    if (!recentlyViewed.length) {
      // Hide the whole carousel when there are no items
      hideRecentlyViewedSection();
      return;
    }

    const productHandles = recentlyViewed.map(product => product.handle);
    // Pass the section's per-breakpoint slider + secondary-image toggles through
    // the ajax URL so collection.ajax.liquid can render the cards accordingly.
    const isd = container.getAttribute("data-inner-desktop") || "true";
    const ist = container.getAttribute("data-inner-tablet") || "true";
    const ism = container.getAttribute("data-inner-mobile") || "true";
    const sec = container.getAttribute("data-secondary") || "false";
    // Cache-buster (_ts): the live storefront can serve a STALE cached copy of
    // this ajax response (e.g. an older render without the secondary image),
    // which is why it works in the theme editor but not live. A unique param
    // per request forces Shopify to return a fresh render every time.
    const url = `/collections/all?view=ajax&products=${productHandles.join(",")}` +
      `&isd=${isd}&ist=${ist}&ism=${ism}&sec=${sec}&_ts=${Date.now()}`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Failed to fetch product data");

      const htmlString = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      const recentlyItemsList = doc.querySelector('.recently_items_list');

      if (recentlyItemsList) {
        container.innerHTML = recentlyItemsList.innerHTML;
      } else {
        hideRecentlyViewedSection();
      }
    } catch (error) {
      console.error("Error:", error);
      hideRecentlyViewedSection();
    }
  }

  // Use this selector for your <ul>
  const container = document.querySelector('.recently-viewed-products');
  if (container) {
    const limitHandler = new LimitHandler();
    limitHandler.storeCurrentProduct();
    await displayRecentlyViewedProducts(container);
  }
});